var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{class:{ lightBg: _vm.lightTheme, darkBg: !_vm.lightTheme },attrs:{"id":"inspire"}},[_c('v-main',{staticClass:"grey lighten-2"},[(_vm.ready === true)?_c('router-view'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }